import { EstimationApi, UploadedFileData } from '../interfaces/api';
import EstimationRequestPost from '../interfaces/estimationRequestPost';


async function startUpload(filename: string, filetype: string, clientName: string, creationTime: number): Promise<{ uploadId: string; key: string }> {
  await delay(100);
  return { uploadId: 'test-upload-id', key: `${clientName}/${creationTime}/${filename}` };
}

async function uploadChunk(uploadId: string, partNumber: number, key: string, fileChunk: Blob): Promise<{ ETag: string; PartNumber: number }> {
  await delay(100);
  return { ETag: 'test-etag', PartNumber: partNumber };
}

async function completeUpload(uploadId: string): Promise<{ message: string; url: string }> {
  await delay(100);
  return { message: 'Test upload complete', url: 'https://test-url.com/image.jpg' };
}


const delay = (ms: number) => new Promise((r) => setTimeout(r, ms));

async function createRequest(estimationRequest: EstimationRequestPost) {
  console.log('Creating request', estimationRequest);
  await delay(1500);
  console.log('Request created');
}

async function uploadImage(clientName: string, creationTime: number, file: UploadedFileData): Promise<void> {
  await delay(1500);

  const bools = [true, false];

  const toFail = bools[Math.floor(Math.random() * bools.length)];

  if (toFail) {
    // eslint-disable-next-line no-throw-literal
    throw 'Error';
  }

  console.log('Request created');
}

async function uploadImageOrder(clientName: string, creationTime: number): Promise<void> {
  await delay(1500);

  const bools = [true, false];

  const toFail = bools[Math.floor(Math.random() * bools.length)];

  if (toFail) {
    // eslint-disable-next-line no-throw-literal
    throw 'Error';
  }

  console.log('Request created');
}

async function abortUpload(uploadId: string, key: string): Promise<void> {
  await delay(100);
  // mock: do nothing
}
/**
 * Estimation API definitions for automated testing.
 *
 * The definitions of this API are used in automated tests as defaults.
 */
const estimationApiTest: EstimationApi = {
  createRequest,
  uploadImage,
  uploadImageOrder,
  startUpload,
  uploadChunk,
  completeUpload,
  abortUpload
};

export default estimationApiTest;

// Question: Can we use redux to store some app state to make the interactions
// seem real?
